
const LocalStorageHelper = {};

LocalStorageHelper.prefix = "GAP.";

LocalStorageHelper.has = (key) => {
	key = LocalStorageHelper.prefix + key;
	if (window.localStorage && window.localStorage[key]) {
		return true;
	}
	return false;
};
LocalStorageHelper.get = (key, defaultValue = "") => {
	const originalKey = key;
	key = LocalStorageHelper.prefix + key;
	if (LocalStorageHelper.has(originalKey)) {
		return window.localStorage[key];
	}
	return defaultValue;
};

LocalStorageHelper.set = (key, value) => {
	try {
		key = LocalStorageHelper.prefix + key;
		window.localStorage[key] = value;
	}
	catch (e) {
		console.warn("Warning: Could not set localstorage for key: " + key + ". " + e);
		return false;
	}
	return true;
};

LocalStorageHelper.clear = (key) => {
	key = LocalStorageHelper.prefix + key;
	delete window.localStorage[key];
};
LocalStorageHelper.clearAll = () => {
	window.localStorage.clear();
};

export default LocalStorageHelper;
